import { Stack, Typography } from '@mui/material';

import type { ForecastItem } from '@/types/Forecast';

interface ForecastBarsProps {
  items: ForecastItem[];
}

export function ForecastBars({ items }: ForecastBarsProps) {
  if (!items.length) return null;

  const getOccupancyColor = (percentage: number): string => {
    if (percentage >= 90) return '#e65638';
    if (percentage >= 75) return '#f3881c';
    if (percentage >= 50) return '#dcc400';

    return '#9bc22a';
  };

  return (
    <Stack
      sx={{
        ml: 1.5,
        width: 160,
      }}
    >
      <Typography>Auslastungsprognose</Typography>
      <Stack
        direction="row"
        sx={{
          mt: 1,
          justifyContent: 'space-between',
        }}
      >
        {items.map((item) => {
          const percentage = Math.max(0, Math.min(100, item.value));
          const hoursAhead = item.horizon / 3600;

          return (
            <Stack
              key={item.horizon}
              sx={{
                textAlign: 'center',
              }}
            >
              <Stack
                sx={{
                  width: 25,
                  height: 50,
                  bgcolor: '#f0f0f0',
                  borderRadius: 1,
                  position: 'relative',
                  mb: 0.5,
                }}
              >
                <Stack
                  title={`${percentage.toFixed(0)}% Auslastung in +${hoursAhead}h`}
                  sx={{
                    position: 'absolute',
                    bottom: 0,
                    width: '100%',
                    height: `${percentage}%`,
                    bgcolor: getOccupancyColor(percentage),
                    borderRadius: 1,
                  }}
                />
              </Stack>
              <Typography variant="caption">+{hoursAhead}h</Typography>
            </Stack>
          );
        })}
      </Stack>
    </Stack>
  );
}
